import { Component, computed, effect, inject, signal, ViewChild, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataMessageService } from '../shared/data-message.service';
import { RecordService } from '../record/record.service';
import { AppToastsService } from '../shared/app-toasts/app-toasts.service';
import moment from 'moment';
import { WebsocketService } from '../shared/websocket.service';
import { Subscription } from 'rxjs';
import { IRptAging } from '../shared/interfaces/rptAging';
import { MatMenu } from '@angular/material/menu';
import { IRptDtx, IRptDtxTot } from '../shared/interfaces/rptDtx';
import { IRptEspCob, IRptEspCobClm } from '../shared/interfaces/rptEspCob';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelperRtnsComponent } from '../shared/helper-rtns.component';
import { IRptIncome } from '../shared/interfaces/rptIncome';

interface IReportsLastUsedParams {
  seldRpt: string,
  fromDt: string,
  toDt: string,
  prov: string,
  ins1: string,
  ins2: string,
  fac: string,
  loc: string,
  opt: string,
  sn: string,
  userID: string,
  lastUsed: number
}[];

@Component({
  selector: 'app-report-dlg',
  imports: [FormsModule],
  standalone: false,
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent {
  _http = inject(HttpClient);
  _help = inject(HelperRtnsComponent);

  @ViewChild(MatMenu) menu!: MatMenu;

  engLang: boolean = false;
  userID: string | undefined;
  userNm: string | undefined;
  userLastNm: string | undefined;
  userFirstNm: string | undefined;
  sioSubscrpt!: Subscription;
  spinnerSignal: WritableSignal<boolean> = signal(false); // Signal to control spinner visibility

  seldRpt: number = 0;
  seldFromDtSignal: WritableSignal<Date | null> = signal(null);
  seldToDtSignal: WritableSignal<Date | null> = signal(null);
  seldProvs: string[] = [];
  seldInses1: string[] = [];
  seldInses2: string[] = [];
  seldFacs: string[] = [];
  seldLocales: string[] = [];
  rptFromDt: string = '';
  rptFromDtSignal: WritableSignal<string> = signal('');
  rptToDt: string = '';
  rptToDtSignal: WritableSignal<string> = signal('');
  lastUsedParamsArr: IReportsLastUsedParams[] = [];

  options: { value: string; desc: string, hide: string }[] = [];
  rptOptionsSignal: WritableSignal<{ value: string; desc: string, hide: string }[]> = signal([]); // Signal to hold report options
  rptRxTabs: string[] = [];

  sioQuerySignal: WritableSignal<string | null> = signal(null);

  provsAllNone = computed(() => [
    {
      pKey: '0',
      alias: '(All/Todos)',
      provName: '',
      provIsCo: '0',
      npi: '',
      provTaxonomy: '',
      ssn: '',
      ein: '',
      taxId: '',
      provAcode: '',
      provTel: '',
      provCel: '',
      poAd1: '',
      poAd2: '',
      poCity: '',
      poSt: '',
      poZip: '',
      provAd1: '',
      provAd2: '',
      provCity: '',
      provSt: '',
      provZip: '',
      provFtpHost: '',
      provFtpUser: '',
      provFtpPw: '',
      lab: '0',
      email: '',
      inactive: '0',
      sqlProcNm: ''
    }, {
      pKey: '-1',
      alias: '(None/Ninguno)',
      provName: '',
      provIsCo: '0',
      npi: '',
      provTaxonomy: '',
      ssn: '',
      ein: '',
      taxId: '',
      provAcode: '',
      provTel: '',
      provCel: '',
      poAd1: '',
      poAd2: '',
      poCity: '',
      poSt: '',
      poZip: '',
      provAd1: '',
      provAd2: '',
      provCity: '',
      provSt: '',
      provZip: '',
      provFtpHost: '',
      provFtpUser: '',
      provFtpPw: '',
      lab: '0',
      email: '',
      inactive: '0',
      sqlProcNm: ''
    },
    ...this._recordService.provs()
  ]);
  trackByProv(_index: number, prov: { pKey: string }): string {
    return prov.pKey;
  };
  seldProvsIDsSignal: WritableSignal<string> = signal('');

  insesAllNone = computed(() => [
    {
      pKey: '0',
      alias: '(All/Todos)',
      name: '',
      payerId: '',
      payerId835: '',
      add1: '',
      add2: '',
      city: '',
      st: '',
      zip: '',
      s1type: '',
      s33bTaxonomy: '',
      s30BalDue: '',
      x837fmtNo: '0',
      x837clmFilInd: '',
      x837usePrvAsRenderAt2310B: '0',
      inactive: '0',
      sqlProcNm: ''
    }, {
      pKey: '-1',
      alias: '(None/Ninguno)',
      name: '',
      payerId: '',
      payerId835: '',
      add1: '',
      add2: '',
      city: '',
      st: '',
      zip: '',
      s1type: '',
      s33bTaxonomy: '',
      s30BalDue: '',
      x837fmtNo: '0',
      x837clmFilInd: '',
      x837usePrvAsRenderAt2310B: '0',
      inactive: '0',
      sqlProcNm: ''
    },
    ...this._recordService.inses().slice(1)
  ]);
  trackByIns(_index: number, ins: { pKey: string }): string {
    return ins.pKey;
  };
  seldInses1IDsSignal: WritableSignal<string> = signal('');
  seldInses2IDsSignal: WritableSignal<string> = signal('');

  facsAllNone = computed(() => [
    {
      pKey: '0',
      alias: '(All/Todos)',
      facNpi: '',
      facName: '',
      facAd1: '',
      facAd2: '',
      facCity: '',
      facSt: '',
      facZip: '',
      inactive: '0',
      sqlProcNm: ''
    }, {
      pKey: '-1',
      alias: '(None/Ninguno)',
      facNpi: '',
      facName: '',
      facAd1: '',
      facAd2: '',
      facCity: '',
      facSt: '',
      facZip: '',
      inactive: '0',
      sqlProcNm: ''
    }, ...this._recordService.facs()
  ]);
  trackByFac(_index: number, fac: { pKey: string }): string {
    return fac.pKey;
  };
  seldFacsIDsSignal: WritableSignal<string> = signal('');

  locsAllNone = computed(() => [
    {
      locName: '(All/Todas)',
      locNo: '0'
    }, {
      locName: '(None/Ninguno)',
      locNo: '-1'
    }, ...this._recordService.locs()]);
  trackByLoc(_index: number, loc: { pKey: string }): string {
    return loc.pKey;
  };
  seldLocalesNoSignal: WritableSignal<string> = signal('');

  rptDtxDataSignal: WritableSignal<IRptDtx> = signal({
    views: [],  // Signal to hold all report views
    parm: [],
    clm: [],
    det: [],
    pay: [],
    tot: []
  }); // Signal to hold all report data
  dtxTotSignal = signal<IRptDtxTot | null>(null);
  rptDtxLoaded: boolean = false;

  rptAgingData!: IRptAging;
  rptAgingLoaded: boolean = false;

  rptEspCobDataSignal: WritableSignal<IRptEspCob> = signal({
    views: [],  // Signal to hold all report views
    parm: [],
    ins: [],
    clm: [],
    det: [],
    pay: [],
    tot: {
      InID: '',
      InLNm: 'Total',
      shoInID: '',
      Usual: '0',
      Xpected: '0',
      AdjPos: '0',
      Payed: '0',
      AdjNeg: '0',
      IBal: '0',
      Pvdo: '0',
      PPayed: '0',
      PDisc: '0',
      PBal: '0',
      Cnt: '0'
    }
  }); // Signal to hold all report data
  rptEspCobLoaded: boolean = false;

  rptIncomeDataSignal: WritableSignal<IRptIncome> = signal({
    views: [],  // Signal to hold all report views
    parm: [],
    ins: [],
    cks: [],
    pay: [],
    tot: {
      InID: '',
      InLNm: 'Total',
      shoInID: '',
      Usual: '0',
      Xpected: '0',
      AdjPos: '0',
      Payed: '0',
      AdjNeg: '0',
      IBal: '0',
      Pvdo: '0',
      PPayed: '0',
      PDisc: '0',
      PBal: '0',
      Cnt: '0'
    }
  }); // Signal to hold all report data
  rptIncomeLoaded: boolean = false;

  constructor(
    private _dataMsgService: DataMessageService,
    private _recordService: RecordService,
    private _appToastsService: AppToastsService,
    private _websocketService: WebsocketService
  ) {
    this.initRptData();

    // 2) effect: any time sioQuery changes (and isn’t null), invoke the sendChat call
    effect(() => {
      const q = this.sioQuerySignal();
      if (q !== null) {
        this.spinnerSignal.set(true);
        this._websocketService.sendChat(
          'query',
          this._recordService.sn,
          q
        );
        // reset it if you don’t want repeats
        this.sioQuerySignal.set(null);
      }
    });
  }

  ngOnInit() {
    this._dataMsgService.currentEngLangStr.subscribe(engLangStr => this.engLangChange(engLangStr)); // Subscription looking for changes in engLang
    this._dataMsgService.currentUserIdStr.subscribe(userIdStr => this.userIdChange(userIdStr)); // Subscription looking for changes in userIdStr
    this._dataMsgService.currentUserLastNmStr.subscribe(userLastNmStr => this.userLastNmChange(userLastNmStr)); // Subscription looking for changes in userLastNmStr
    this._dataMsgService.currentUserFirstNmStr.subscribe(userFirstNmStr => this.userFirstNmChange(userFirstNmStr)); // Subscription looking for changes in userLastNmStr

    this.options = [
      { value: 'ignorPayAftToDt', desc: (this.engLang ? 'Ignore payments after TO date' : 'Ignorar pagos después fecha HASTA'), hide: ',1,3,4,5,6,7,8,' },
      { value: 'woAnyPay', desc: (this.engLang ? 'Only show claims with no payment' : 'Mostrar solo casos sin pago'), hide: ',1,2,3,5,6,7,8,' },
      { value: 'deferSecndry', desc: (this.engLang ? 'Do not show sec. claim until pri. payed' : 'No mostrar deuda sec. hasta pago del pri.'), hide: ',1,2,3,5,6,7,8,' },
      { value: 'officeOnly', desc: (this.engLang ? 'Office claims only' : 'Solo casos oficina'), hide: ',7,' },
      { value: 'nonOfficeOnly', desc: (this.engLang ? 'Exclude office claims' : 'Excluir casos oficina'), hide: ',7,' },
      { value: 'exclPvdo', desc: (this.engLang ? 'Exclude cash' : 'Excluir cash'), hide: ',1,2,5,6,8,' },
      { value: 'grpByRxDt', desc: (this.engLang ? 'By pay received date' : 'Por fecha pago recibido'), hide: ',1,2,4,5,6,7,8,' }
    ];

    this._http.get<IReportsLastUsedParams[]>(this._help.urlDB + '/api/get-reportsLastUsedParams/' + this._recordService.sn + '/' + this.userID,
      { headers: new HttpHeaders({ 'Accept': 'application/json' }) })
      .subscribe({
        next: (data: IReportsLastUsedParams[]) => {
          console.log('data', data);
          this.lastUsedParamsArr = data;
          const lastUsedObj = this.lastUsedParamsArr.find(p => p.lastUsed === 1);
          console.log('lastUsedObj', lastUsedObj);
          if (lastUsedObj) {
            this.seldRpt = +lastUsedObj.seldRpt;
          }
          this.loadLastUsedParamsFromArray();
        },
        error: (err: any) => {
          console.error(err);
          this.lastUsedParamsArr = [];
        }
      });

    this.sioSubscrpt = this._websocketService.getMessages().subscribe((dataSet) => { // Sets listenning events
      console.log('%c' + 'dataSet ReportsComponent', 'color: green; background: yellow; font-size: 12px');
      console.dir(dataSet);

      if (dataSet?.error) {
        // TODO/: Error toast
      } else {
        if (dataSet?.length > 0) {

          if (dataSet[0].sqlProcNm?.startsWith('spRptAging2')) {
            const len = dataSet[0].sqlProcNm.length;
            const tabl = dataSet[0].sqlProcNm.substring(len - 3, len);
            switch (tabl) {
              case 'ins':
                this.rptAgingData.ins = dataSet;
                break;
              case 'clm':
                this.rptAgingData.clm = dataSet;
                break;
              case 'det':
                this.rptAgingData.det = dataSet;
                break;
              case 'pad':
                this.rptAgingData.pad = dataSet;
                break;
              case 'end':
                let tInLNm: string = this.engLang ? 'Totals' : 'Totales';
                let tag30: number = 0;
                let tag60: number = 0;
                let tag90: number = 0;
                let tag120: number = 0;
                let tag150: number = 0;
                let tag6m: number = 0;
                let tag1y: number = 0;
                let tag2y: number = 0;
                let tag3y: number = 0;
                let tbalance: number = 0;
                let tc30: number = 0;
                let tc60: number = 0;
                let tc90: number = 0;
                let tc120: number = 0;
                let tc150: number = 0;
                let tc6m: number = 0;
                let tc1y: number = 0;
                let tc2y: number = 0;
                let tc3y: number = 0;
                let ttCount: number = 0;

                this.rptAgingData.ins.forEach(obj => {
                  tag30 += +obj.ag30.replace(',', '');
                  tag60 += +obj.ag60.replace(',', '');
                  tag90 += +obj.ag90.replace(',', '');
                  tag120 += +obj.ag120.replace(',', '');
                  tag150 += +obj.ag150.replace(',', '');
                  tag6m += +obj.ag6m.replace(',', '');
                  tag1y += +obj.ag1y.replace(',', '');
                  tag2y += +obj.ag2y.replace(',', '');
                  tag3y += +obj.ag3y.replace(',', '');
                  tbalance += +obj.balance;
                  tc30 += +obj.c30.replace(',', '');
                  tc60 += +obj.c60.replace(',', '');
                  tc90 += +obj.c90.replace(',', '');
                  tc120 += +obj.c120.replace(',', '');
                  tc150 += +obj.c150.replace(',', '');
                  tc6m += +obj.c6m.replace(',', '');
                  tc1y += +obj.c1y.replace(',', '');
                  tc2y += +obj.c2y.replace(',', '');
                  tc3y += +obj.c3y.replace(',', '');
                  ttCount += +obj.tCount.replace(',', '');
                });
                this.rptAgingData.ins.push({
                  i2cKey: '',
                  InLNm: tInLNm,
                  InID: '',
                  reclTyp: '',
                  oInLNm: '',
                  ag30: tag30.toString(),
                  ag60: tag60.toString(),
                  ag90: tag90.toString(),
                  ag120: tag120.toString(),
                  ag150: tag150.toString(),
                  ag6m: tag6m.toString(),
                  ag1y: tag1y.toString(),
                  ag2y: tag2y.toString(),
                  ag3y: tag3y.toString(),
                  balance: tbalance,
                  c30: tc30.toString(),
                  c60: tc60.toString(),
                  c90: tc90.toString(),
                  c120: tc120.toString(),
                  c150: tc150.toString(),
                  c6m: tc6m.toString(),
                  c1y: tc1y.toString(),
                  c2y: tc2y.toString(),
                  c3y: tc3y.toString(),
                  tCount: ttCount.toString(),
                  expandCol: '',
                  printing: '',
                  sqlProcNm: ''
                });
                this.spinnerSignal.set(false);
                this.rptAgingLoaded = true;

                console.log(this.rptAgingData);
                break;
              default:
            }

          } else if (dataSet[0].sqlProcNm?.startsWith('spRptDtx')) {
            if (dataSet[0].sqlProcNm === 'spRptDtx') {
              console.log('views dataSet arrived');
              this.rptDtxDataSignal.update(current => ({
                views: dataSet.filter((v: { name: string }) => v.name.length > 0),  // replace old views only. Filter out any blank rows
                parm: current.parm,   // preserve
                clm: current.clm,     // preserve
                det: current.det,     // preserve
                pay: current.pay,     // preserve
                tot: current.tot      // preserve
              }));
              this.spinnerSignal.set(false);
            }
            if (dataSet[0].sqlProcNm?.endsWith('-parm')) {
              console.log('parm dataSet arrived');
              this.rptDtxDataSignal.update(current => ({
                views: current.views, // preserve
                parm: dataSet,        // replace old parm only
                clm: current.clm,     // preserve
                det: current.det,     // preserve
                pay: current.pay,     // preserve
                tot: current.tot      // preserve
              }));

              const df: Date = moment(dataSet[0].parmFromDt, 'MM/DD/YYYY').toDate();
              this.seldFromDtSignal.set(df);
              const dt: Date = moment(dataSet[0].parmToDt, 'MM/DD/YYYY').toDate();
              this.seldToDtSignal.set(dt);
              this.seldProvs = [];
              if (dataSet[0]?.parmProv?.match(/^\|/g)) {  // New way of specifying providers; '|1|3|6|...9|'
                this.seldProvs = dataSet[0].parmProv.slice(1, -1).split('|');  // Get rid of leading & trailing | , then => ["x", "y", "z"]
              } else if (dataSet[0]?.parmProv?.match(/\(\d+\)/g)) {
                this.seldProvs.push(dataSet[0].parmProv.match(/\(\d+\)/g)[0].replace(/\(/g, '').replace(/\)/g, ''));
              }
              this.seldInses1 = [];
              if (dataSet[0]?.parmIns1?.match(/^\|/g)) {  // New way of specifying inses1; '|1|3|6|...9|'
                this.seldInses1 = dataSet[0].parmIns1.slice(1, -1).split('|');  // Get rid of leading & trailing | , then => ["x", "y", "z"]
              } else if (dataSet[0]?.parmIns1?.match(/\(\d+\)/g)) {
                this.seldInses1.push(dataSet[0].parmIns1.match(/\(\d+\)/g)[0].replace(/\(/g, '').replace(/\)/g, ''));
              }
              this.seldInses2 = [];
              if (dataSet[0]?.parmIns2?.match(/^\|/g)) {  // New way of specifying inses2; '|1|3|6|...9|'
                this.seldInses2 = dataSet[0].parmIns2.slice(1, -1).split('|');  // Get rid of leading & trailing | , then => ["x", "y", "z"]
              } else if (dataSet[0]?.parmIns2?.match(/\(\d+\)/g)) {
                this.seldInses2.push(dataSet[0].parmIns2.match(/\(\d+\)/g)[0].replace(/\(/g, '').replace(/\)/g, ''));
              }
              this.seldFacs = [];
              if (dataSet[0]?.parmFac?.match(/^\|/g)) {  // New way of specifying facilities; '|1|3|6|...9|'
                this.seldFacs = dataSet[0].parmFac.slice(1, -1).split('|');  // Get rid of leading & trailing | , then => ["x", "y", "z"]
              } else if (dataSet[0]?.parmFac?.match(/\(\d+\)/g)) {
                this.seldFacs.push(dataSet[0].parmFac.match(/\(\d+\)/g)[0].replace(/\(/g, '').replace(/\)/g, ''));
              }
              this.seldLocales = [];
              if (dataSet[0]?.parmLocale?.match(/^\|/g)) {  // New way of specifying locale; '|0001|0003|0006|...0009|'
                this.seldLocales = dataSet[0].parmLocale.slice(1, -1).split('|');  // Get rid of leading & trailing | , then => ["x", "y", "z"]
              } else if (dataSet[0]?.parmLocale?.match(/^\d{4}/g)) {  // "0001 - OFICINA 00"
                this.seldLocales.push(dataSet[0].parmLocale.match(/^\d{4}/g)[0]);
              }
              this.rptOptionsSignal.set([]);
              let opt: any;
              if (dataSet[0].parmOHA) {
                if (dataSet[0].parmOHA === 'O' || dataSet[0].parmOHA === 'OFICINA') {
                  opt = this.options.filter(o => o.value === 'officeOnly');
                } else if (dataSet[0].parmOHA === 'H' || dataSet[0].parmOHA === 'FAC/HOSP') {
                  opt = this.options.filter(o => o.value === 'nonOfficeOnly');
                }
                if (opt && opt?.length === 1) {
                  this.rptOptionsSignal.set(opt);
                }
              }
            }
            if (dataSet[0].sqlProcNm?.endsWith('-clm')) {
              let i = 0;
              dataSet.forEach((clm: any) => { clm['index'] = i++; }); // Add index to each clm object for odd/even alternate background colors
              console.log('clm dataSet arrived');
              this.rptDtxDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                clm: dataSet,         // replace clm only
                det: current.det,     // reserve
                pay: current.pay,     // preserve
                tot: current.tot      // preserve
              }));
            }
            if (dataSet[0].sqlProcNm?.endsWith('-det')) {
              console.log('det dataSet arrived');
              this.rptDtxDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                clm: current.clm,     // preserve
                det: dataSet,         // replace det only
                pay: current.pay,     // preserve
                tot: current.tot      // preserve
              }));
            }
            if (dataSet[0].sqlProcNm?.endsWith('-pay')) {
              console.log('pay dataSet arrived');
              this.rptDtxDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                clm: current.clm,     // preserve
                det: current.det,     // preserve
                pay: dataSet,         // replace pay only
                tot: current.tot      // preserve
              }));
            }
            if (dataSet[0].sqlProcNm?.endsWith('-tot')) {
              console.log('tot dataSet arrived');
              this.rptDtxDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                clm: current.clm,     // preserve
                det: current.det,     // preserve
                pay: current.pay,     // preserve
                tot: dataSet          // replace tot only
              }));
              this.dtxTotSignal.set(dataSet[0]);
              this.spinnerSignal.set(false);
            }
            if (dataSet[0].sqlProcNm === 'spRptDtx-new') {
              console.log('sql', dataSet[0].sql);
              this.rptDtxDataSignal.update(current => {
                current.views.splice(0, 0, dataSet[0]); // insert at position 0
                return {
                  ...current,
                  views: current.views
                };
              });
              // Display newly created view
              const q = "EXEC dbo.spRptDtx @viewNm = '" + dataSet[0].name + "';";
              window.scroll(0, 0);
              console.log('%c' + 'query ' + q, 'color: green; background: yellow; font-size: 12px');
              this._websocketService.sendChat(
                'query',
                this._recordService.sn,
                q
              );
              this.spinnerSignal.set(true);
            }
            this.rptDtxLoaded = true;

            if (dataSet[0].sqlProcNm === 'spRptDtxDelete') {
              if (+dataSet[0].deletedViews === 1) {
                let vnam = dataSet[0].deletedViewNm;

                console.log('vnam', vnam);
                console.log('before', this.rptDtxDataSignal().views.length);

                this.rptDtxDataSignal.update(current => ({
                  ...current,
                  views: current.views.filter(cvw => cvw.name !== vnam)
                }));
                this.initRptData();

                console.log('after', this.rptDtxDataSignal().views.length);
              }
              this.spinnerSignal.set(false);
            }

          } else if (dataSet[0].sqlProcNm?.startsWith('spRptEspVsCob2')) {
            // console.log('dataSet[0]', dataSet[0]);
            if (dataSet[0].sqlProcNm === 'spRptEspVsCob2') {
              const result: any[] = dataSet.filter((view: { name: string }) => { return view.name });
              console.log('views dataSet arrived');
              this.rptEspCobDataSignal.update(current => ({
                views: result,       // replace old views only
                parm: current.parm,   // preserve
                ins: current.ins,     // preserve
                clm: current.clm,     // preserve
                det: current.det,     // preserve
                pay: current.pay,     // preserve
                tot: current.tot      // preserve
              }));
              this.rptEspCobLoaded = true;
              this.spinnerSignal.set(false);
            }

            if (dataSet[0].sqlProcNm.endsWith('-ins')) {
              const result: any[] = dataSet.filter((ins: { Cnt: string }) => { return +ins.Cnt > 0 });
              let i = 0;
              result.forEach(ins => {
                ins['index'] = i++; // Add index to each ins object for odd/even alternate background colors
                ins['printing'] = false; // True when printing a particular plan clm list to show spinner
              });
              console.dir(result);
              this.rptEspCobDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                ins: result,         // replace ins only
                clm: current.clm,     // preserve
                det: current.det,     // preserve
                pay: current.pay,     // preserve
                tot: {
                  InID: '',
                  InLNm: 'Total',
                  shoInID: '',
                  Usual: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.Usual || 0)) }, 0),
                  Xpected: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.Xpected || 0)) }, 0),
                  AdjPos: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.AdjPos || 0)) }, 0),
                  Payed: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.Payed || 0)) }, 0),
                  AdjNeg: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.AdjNeg || 0)) }, 0),
                  IBal: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.IBal || 0)) }, 0),
                  Pvdo: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.Pvdo || 0)) }, 0),
                  PPayed: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.PPayed || 0)) }, 0),
                  PDisc: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.PDisc || 0)) }, 0),
                  PBal: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.PBal || 0)) }, 0),
                  Cnt: result.reduce((acc, o) => { return acc + (this._recordService.makeNum(o.Cnt || 0)) }, 0)
                }
              }));
              this.rptRxTabs.push(dataSet[0].sqlProcNm);
            }

            if (dataSet[0].sqlProcNm.endsWith('-clm')) {
              dataSet.forEach((clm: { last: string }) => { clm['last'] = '0'; }); // Add last for last clm row in ins

              const result: IRptEspCobClm[] = dataSet.filter((clm: { CasID: string }) => { return +clm.CasID });
              if (dataSet.length !== result.length + 1) {
                debugger; // Should not happen
              }

              // a map from casInID → next index to mutate in place result
              const counters = new Map<string, number>();
              for (const item of result) {
                const key = item.casInID;
                // get the current counter (or start at 0)
                const idx = counters.get(key) ?? 0;
                // assign it (as a string, since your interface uses string)
                item.index = String(idx);
                // increment for next time we see this casInID
                counters.set(key, idx + 1);
              }

              // mark last row property "last" as "1" for last occurrence of each casInID
              this.markLastRowPerKey(result, 'casInID');

              console.log('clm-result', result);
              this.rptEspCobDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                ins: current.ins,     // preserve
                clm: result,          // replace
                det: current.det,     // preserve
                pay: current.pay,     // preserve
                tot: current.tot      // preserve
              }));
              this.rptRxTabs.push(dataSet[0].sqlProcNm);
            }

            if (dataSet[0].sqlProcNm.endsWith('-det')) {
              dataSet.forEach((det: { last: string }) => { det['last'] = '0'; }); // Add last for last det row in clm

              const result: any[] = dataSet.filter((det: { keyDetCasID: string }) => { return det.keyDetCasID });
              if (dataSet.length !== result.length + 1) {
                debugger;
              }

              // a map from casInID → next index to mutate in place result
              const counters = new Map<string, number>();
              for (const item of result) {
                const key = item.keyDetCasID;
                // get the current counter (or start at 0)
                const idx = counters.get(key) ?? 0;
                // assign it (as a string, since your interface uses string)
                item.index = String(idx);
                // increment for next time we see this casInID
                counters.set(key, idx + 1);
              }

              // mark last row property "last" as "1" for last occurrence of each keyDetCasID
              this.markLastRowPerKey(result, 'keyDetCasID');

              console.log('det-result', result);
              this.rptEspCobDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                ins: current.ins,     // preserve
                clm: current.clm,     // preserve
                det: result,          // replace
                pay: current.pay,     // preserve
                tot: current.tot      // preserve
              }));
              this.rptRxTabs.push(dataSet[0].sqlProcNm);
            }

            if (dataSet[0].sqlProcNm.endsWith('-pay')) {
              dataSet.forEach((pay: { last: string }) => { pay['last'] = '0'; }); // Add last for last pay row in clm

              const result: any[] = dataSet.filter((pay: { keyPayCasID: string }) => { return pay.keyPayCasID });
              if (dataSet.length !== result.length + 1) {
                debugger;
              }

              // a map from casInID → next index to mutate in place result
              const counters = new Map<string, number>();
              for (const item of result) {
                const key = item.keyPayCasID;
                // get the current counter (or start at 0)
                const idx = counters.get(key) ?? 0;
                // assign it (as a string, since your interface uses string)
                item.index = String(idx);
                // increment for next time we see this casInID
                counters.set(key, idx + 1);
              }

              // mark last row property "last" as "1" for last occurrence of each keyPayCasID
              this.markLastRowPerKey(result, 'keyPayCasID');

              console.log('pay-result', result);
              this.rptEspCobDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                ins: current.ins,     // preserve
                clm: current.clm,     // preserve
                det: current.det,     // preserve
                pay: result,          // replace
                tot: current.tot      // preserve
              }));
              this.rptRxTabs.push(dataSet[0].sqlProcNm);
            }

            if (this.rptRxTabs.length === 4) {
              this.rptEspCobLoaded = true;
              this.spinnerSignal.set(false);
            }

          } else if (dataSet[0].sqlProcNm?.startsWith('spRptIncome2')) {
            // console.log('dataSet[0]', dataSet[0]);
            if (dataSet[0].sqlProcNm === 'spRptIncome2') {
              const result: any[] = dataSet.filter((view: { name: string }) => { return view.name });
              console.log('views dataSet arrived');
              this.rptIncomeDataSignal.update(current => ({
                views: result,        // replace old views only
                parm: current.parm,   // preserve
                ins: current.ins,     // preserve
                cks: current.cks,     // preserve
                pay: current.pay,     // preserve
                tot: current.tot      // preserve
              }));
              this.rptIncomeLoaded = true;
              this.spinnerSignal.set(false);
            }

            if (dataSet[0].sqlProcNm.endsWith('-ins')) {
              const result: any[] = dataSet.filter((ins: { Cnt: string }) => { return +ins.Cnt > 0 });
              let i = 0;
              result.forEach(ins => {
                ins['index'] = i++; // Add index to each ins object for odd/even alternate background colors
                ins['printing'] = false; // True when printing a particular plan ck list to show spinner
              });
              console.dir(result);
              this.rptIncomeDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                ins: result,         // replace ins only
                cks: current.cks,     // preserve
                pay: current.pay,     // preserve
                tot: {
                  InID: '',
                  InLNm: 'Total',
                  shoInID: '',
                }
              }));
              this.rptRxTabs.push(dataSet[0].sqlProcNm);
            }

            if (dataSet[0].sqlProcNm.endsWith('-cks')) {
              const result: any[] = dataSet;
              let i = 0;
              result.forEach(cks => {
                cks['index'] = i++; // Add index to each cks object for odd/even alternate background colors
                cks['printing'] = false; // True when printing a particular plan ck list to show spinner
              });
              console.dir(result);
              this.rptIncomeDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                ins: current.ins,     // preserve
                cks: result,          // replace cks only
                pay: current.pay,     // preserve
                tot: current.tot      // preserve
              }));
              this.rptRxTabs.push(dataSet[0].sqlProcNm);
            }

            if (dataSet[0].sqlProcNm.endsWith('-pay')) {
              const result: any[] = dataSet;
              let i = 0;
              result.forEach(pay => {
                pay['index'] = i++; // Add index to each cks object for odd/even alternate background colors
              });
              console.dir(result);
              this.rptIncomeDataSignal.update(current => ({
                views: current.views, // preserve
                parm: current.parm,   // preserve
                ins: current.ins,     // preserve
                cks: current.cks,     // preserve
                pay: result,          // replace pay only
                tot: current.tot      // preserve
              }));
              this.rptRxTabs.push(dataSet[0].sqlProcNm);
            }

            console.log('rptRxTabs', this.rptRxTabs);
            if (this.rptRxTabs.length === 3) {
              this.rptIncomeLoaded = true;
              this.spinnerSignal.set(false);
            }
          }
        }
      }
    });

    this.seldFromDtSignal.set(new Date());
    this.seldToDtSignal.set(new Date());
    this.seldProvs = [];
    this.seldInses1 = [];
    this.seldInses2 = [];
    this.seldFacs = [];
    this.seldLocales = [];
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.sioSubscrpt.unsubscribe();
    const params = this.lastUsedParamsArr.map(p => {
      p.fromDt = moment(p.fromDt).format('YYYY-MM-DD');
      p.toDt = moment(p.toDt).format('YYYY-MM-DD'); return p;
    });
    const body = JSON.stringify({ "lastUsedParams": params });

    this._http.post<any>(this._help.urlDB + '/api/post-ReportsLastUsedParams', body, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) })
      .subscribe({
        next: data => {
          console.log('ReportsLastUsedParams saved', data);
        },
        error: error => console.error(error)
      });
  }

  markLastRowPerKey(data: any[], keyField: string): void {
    for (let i = data.length - 1, seen = new Set<string>(); i >= 0; i--) {
      const k = data[i][keyField] ?? '';
      if (seen.has(k)) {
        data[i].last = '0';
      } else {
        data[i].last = '1';   // first time we see k from the end ⇒ it's the last occurrence
        seen.add(k);
      }
    }
  }

  initRptData(): void {
    this.rptAgingData = {
      ins: [],
      clm: [],
      det: [],
      pad: []
    };
    this.rptAgingLoaded = false;

    this.rptDtxDataSignal.update(current => ({
      views: current.views,
      parm: [],
      clm: [],
      det: [],
      pay: [],
      tot: []
    }));
    this.dtxTotSignal.set(null);
    this.rptDtxLoaded = false;

    this.rptEspCobDataSignal.update(current => ({
      views: current.views,
      parm: [],
      ins: [],
      clm: [],
      det: [],
      pay: [],
      tot: {
        InID: '',
        InLNm: 'Total',
        shoInID: '',
        Usual: '0',
        Xpected: '0',
        AdjPos: '0',
        Payed: '0',
        AdjNeg: '0',
        IBal: '0',
        Pvdo: '0',
        PPayed: '0',
        PDisc: '0',
        PBal: '0',
        Cnt: '0'
      }
    }));
    this.rptEspCobLoaded = false;

    this.rptIncomeDataSignal.update(current => ({
      views: current.views,
      parm: [],
      ins: [],
      cks: [],
      pay: [],
      tot: {
        InID: '',
        InLNm: 'Total',
        shoInID: '',
        Usual: '0',
        Xpected: '0',
        AdjPos: '0',
        Payed: '0',
        AdjNeg: '0',
        IBal: '0',
        Pvdo: '0',
        PPayed: '0',
        PDisc: '0',
        PBal: '0',
        Cnt: '0'
      }
    }));
    this.rptIncomeLoaded = false;
  }

  engLangChange(engLangStr: string) { // for when language changes
    engLangStr === 'true' ? this.engLang = true : this.engLang = false;
  }

  userIdChange(userIdStr: string) {
    this.userID = userIdStr;
  }

  userLastNmChange(userLastNmStr: string) {
    this.userLastNm = userLastNmStr;
  }

  userFirstNmChange(userFirstNmStr: string) {
    this.userFirstNm = userFirstNmStr;
  }

  optionSelected(opt: any): void {
    console.log('lastUsedParamsArray() called', this.lastUsedParamsArr);

    // If officeOnly is being added, remove nonOfficeOnly if it exists
    if (opt.value === 'officeOnly' && this.rptOptionsSignal()?.find(o => o.value === 'nonOfficeOnly')) {
      this.rptOptionsSignal.update(current => current.filter(o => o.value !== 'nonOfficeOnly'));
    }
    // If nonOfficeOnly is being added, remove officeOnly if it exists
    if (opt.value === 'nonOfficeOnly' && this.rptOptionsSignal()?.find(o => o.value === 'officeOnly')) {
      this.rptOptionsSignal.update(current => current.filter(o => o.value !== 'officeOnly'));
    }

    if (this.rptOptionsSignal() && !this.rptOptionsSignal()?.find(o => o.value === opt.value)) {
      switch (this.seldRpt) {
        case 2:
          if (opt.value === 'deferSecndry') {
            return; // Exclude cash not applicable to Aging report
          }
      }
      this.rptOptionsSignal.update(current => [...current, opt]); // Add option to rptOptionsSignal

      if (this.rptAgingData.ins.length) { // Redisplay only if there is data
        this.fetchRpt();
      }
      if (this.rptEspCobDataSignal().ins.length) { // Redisplay only if there is data
        this.fetchRpt();
      }
    }

    this.updateLastUsedParamsArray();
  }

  removeOption(event: MouseEvent, opt: { value: string; desc: string }) {
    console.log('lastUsedParamsArray() called', this.lastUsedParamsArr);

    event.stopPropagation();

    this.rptOptionsSignal.update(options =>
      options.filter(o => !(o.value === opt.value && o.desc === opt.desc))
    );

    if (this.rptAgingData.ins.length) { // Redisplay only if there is data
      this.fetchRpt();
    }
    if (this.rptEspCobDataSignal().ins.length) { // Redisplay only if there is data
      this.fetchRpt();
    }

    this.updateLastUsedParamsArray();
  }

  onChange_params(event: any, typ: string): void {
    console.log('onChange_params(...) event =', event);

    const fromDt = this.seldFromDtSignal();
    const toDt = this.seldToDtSignal();

    this.initRptData(); // Clear any shown data if report params changed
    if (typ.match(/^(p|i1|i2|f|l)$/)) {
      if (event.value.includes('0')) {  // Clicked ALL ckbx
        switch (typ) {
          case 'p':
            this.seldProvs = this.provsAllNone().map(p => p.pKey).filter(p => +p > 0); // replace with every pKey
            break;
          case 'i1':
            this.seldInses1 = this.insesAllNone().map(i => i.pKey).filter(i => +i > 0); // replace with every pKey
            break;
          case 'i2':
            this.seldInses2 = this.insesAllNone().map(i => i.pKey).filter(i => +i > 0); // replace with every pKey
            break;
          case 'f':
            this.seldFacs = this.facsAllNone().map(f => f.pKey).filter(f => +f > 0); // replace with every pKey
            break;
          case 'l':
            this.seldLocales = this.locsAllNone().map(l => l.locNo).filter(l => +l > 0); // replace with every locNo
            break;
        }
      } else if (event.value.includes('-1')) {  // Clicked NONE to clear all selections
        switch (typ) {
          case 'p':
            this.seldProvs = [];
            break;
          case 'i1':
            this.seldInses1 = [];
            break;
          case 'i2':
            this.seldInses2 = [];
            break;
          case 'f':
            this.seldFacs = [];
            break;
          case 'l':
            this.seldLocales = [];
            break;
        }
      }
    } else if (typ === 'fromDt') {
      if (fromDt && toDt && fromDt.getTime() > toDt.getTime()) {
        this.seldToDtSignal.set(fromDt); // If From date is greater than To date, set To date to From date
      }
    } else if (typ === 'toDt') {
      if (toDt && fromDt && toDt.getTime() < fromDt.getTime()) {
        this.seldFromDtSignal.set(toDt); // If To date is less than From date, set From date to To date
      }
    }

    this.updateLastUsedParamsArray();
  }

  updateLastUsedParamsArray() {
    if (this.seldRpt) {
      const fromDt = this.seldFromDtSignal();
      const toDt = this.seldToDtSignal();

      const currentRptParams = {
        seldRpt: this.seldRpt.toString(),
        fromDt: moment(fromDt).format('MM/DD/YYYY'),
        toDt: moment(toDt).format('MM/DD/YYYY'),
        prov: this.seldProvs.join(','),
        ins1: this.seldInses1.join(','),
        ins2: this.seldInses2.join(','),
        fac: this.seldFacs.join(','),
        loc: this.seldLocales.join(','),
        lastUsed: 0,
        opt: this.rptOptionsSignal().map(o => o.value).join(','),
        userID: this.userID ?? '',
        sn: this._recordService.sn
      };

      const prevSeldRptParams = this.lastUsedParamsArr.find(p => +p.seldRpt === +currentRptParams?.seldRpt); // Look for current entry in this.lastUsedParamsArr
      if (prevSeldRptParams) {
        // Update existing entry in this.lastUsedParamsArr
        prevSeldRptParams.seldRpt = currentRptParams.seldRpt.toString();
        prevSeldRptParams.fromDt = currentRptParams.fromDt;
        prevSeldRptParams.toDt = currentRptParams.toDt;
        prevSeldRptParams.prov = currentRptParams.prov;
        prevSeldRptParams.ins1 = currentRptParams.ins1;
        prevSeldRptParams.ins2 = currentRptParams.ins2;
        prevSeldRptParams.fac = currentRptParams.fac;
        prevSeldRptParams.loc = currentRptParams.loc;
        prevSeldRptParams.lastUsed = 0;
        prevSeldRptParams.opt = currentRptParams.opt;
      } else {
        // Add new entry paramObj to this.lastUsedParamsArr
        this.lastUsedParamsArr.push(currentRptParams);
        console.log('currentRptParams.sn', currentRptParams.sn);
      }
    }
  }

  seldProvsHead(): string {
    let nms: string = '';
    for (let p = 0; p < this.seldProvs.length; p++) {
      if (+this.seldProvs[p] === 0) {  // If All selected don't bother to iterate selected array
        nms = this.provsAllNone().find(p => +p.pKey === 0)?.alias ?? '';
        break;
      }

      if (nms) {
        nms += ',';
      }
      nms += this.seldProvs[p] + ' ' + (this.provsAllNone().find(pr => pr.pKey === (this.seldProvs[p]))?.alias ?? '').substring(0, 5);
    };
    return nms;
  }

  seldFacsHead(): string {
    let nms: string = '';
    for (let f = 0; f < this.seldFacs.length; f++) {
      if (+this.seldFacs[f] === 0) {  // If All selected don't bother to iterate selected array
        nms = this.facsAllNone().find(p => +p.pKey == 0)?.alias ?? '';
        break;
      }

      if (nms) {
        nms += ',';
      }
      nms += this.seldFacs[f] + ' ' + (this.facsAllNone().find(pr => pr.pKey === this.seldFacs[f]))?.alias.substring(0, 5);
    };
    return nms;
  }

  seldLocalesHead(): string {
    let nms: string = '';
    for (let l = 0; l < this.seldLocales.length; l++) {
      if (+this.seldLocales[l] === 0) {  // If All selected don't bother to iterate selected array
        nms = (this.locsAllNone().find(lc => +lc.locNo == 0)?.locName) ?? '';
        break;
      }

      if (nms) {
        nms += ',';
      }
      nms += (this.locsAllNone().find(lc => +lc.locNo === +this.seldLocales[l]))?.locName.substring(0, 10);
    };
    return nms;
  }

  seldInsesHead(insArr: any[]): string {
    let nms: string = '';
    for (let i = 0; i < insArr.length; i++) {
      if (+insArr[i] === 0) {  // If All selected don't bother to iterate selected array
        nms = (this.insesAllNone().find(seg => +seg.pKey == 0)?.alias) ?? '';
        break;
      }

      if (nms) {
        nms += ',';
      }
      nms += insArr[i] + ' ' + (this.insesAllNone().find(seg => seg.pKey === insArr[i]))?.alias.substring(0, 5);
    };
    return nms;
  }

  fmtCurrency(amnt: number, symb: string = '') {
    const parts = amnt.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return symb + parts.join('.');
  }

  hideIfNotAllowedRptOpts(opt: any): boolean {
    return opt?.hide.includes(this.seldRpt.toString());
  }

  markLastUsedRpt(): void {
    this.lastUsedParamsArr.forEach(p => {
      if (+p.seldRpt === this.seldRpt) {
        p.lastUsed = 1;
      } else {
        p.lastUsed = 0;
      }
    });
  }

  fetchRpt(nuevo?: boolean) {
    this.loadLastUsedParamsFromArray();

    this.rptRxTabs = [];
    this.rptDtxLoaded = false;
    this.rptAgingLoaded = false;
    this.rptEspCobLoaded = false;
    this.rptIncomeLoaded = false;

    let errMsgEn: string[] = [];
    let errMsgSp: string[] = [];

    let frMom = moment(this.seldFromDtSignal());
    let toMom = moment(this.seldToDtSignal());

    if (!this.seldRpt) {
      errMsgEn.push('Select the desired report. ');
      errMsgSp.push('Seleccione el reporte deseado. ');
    }

    if (!frMom.isValid() || !toMom.isValid() || frMom.isAfter(toMom)) {
      errMsgEn.push('Verify dates from/to. "From" date cannot be greater than "To" date.');
      errMsgSp.push('Coteje fechas desde/hasta. Fecha "Hasta" no puede ser mayor que fecha "Desde".');
    }

    if (this.seldProvs.length === 0) {
      if (+this.seldRpt > 2) { // Avoid dtx report
        errMsgEn.push('Select at least one provider.');
        errMsgSp.push('Seleccione al menos un proveedor.');
      }
    }

    if (errMsgEn.length) {
      let errMsg;
      if (this.engLang) {
        errMsg = errMsgEn;
      } else {
        errMsg = errMsgSp;
      }

      errMsg.forEach(msg => {
        this._appToastsService.updateDeadCenter(false);
        this._appToastsService.show(msg, { header: (this.engLang ? 'Check the following:' : 'Coteje lo siguiente:'), autohide: true, warning: true });
      });
    } else {  // Good to go, build query
      let qry: string = '';
      let fromDt = (moment(this.seldFromDtSignal())).format('YYYYMMDD');
      let toDt = (moment(this.seldToDtSignal())).format('YYYYMMDD');

      this.rptFromDt = frMom.format('MM/DD/YY');
      this.rptFromDtSignal.set(this.rptFromDt);
      this.rptToDt = toMom.format('MM/DD/YY');
      this.rptToDtSignal.set(this.rptToDt);

      if (this.seldProvs.find(itm => itm === '0')) {//TODO: check if this is needed for Aging rpt ASAP
        this.seldProvs = ['0'];
      } else if (this.seldProvs.find(itm => itm === '-1')) {
        this.seldProvs = ['-1'];
      } else if (this.seldProvs.length === 1 && this.seldProvs[0] === '') {
        this.seldProvs = [];  // Excludes this parameter from query
      }

      if (this.seldInses1.find(itm => itm === '0')) {//TODO: check if this is needed for Aging rpt ASAP
        this.seldInses1 = ['0'];
      } else if (this.seldInses1.find(itm => itm === '-1')) {
        this.seldInses1 = ['-1'];
      } else if (this.seldInses1.length === 1 && this.seldInses1[0] === '') {
        this.seldInses1 = []; // Excludes this parameter from query
      }

      if (this.seldInses2.find(itm => itm === '0')) {
        this.seldInses2 = ['0'];
      } else if (this.seldInses2.find(itm => itm === '-1')) {
        this.seldInses2 = ['-1'];
      } else if (this.seldInses2.length === 1 && this.seldInses2[0] === '') {
        this.seldInses2 = []; // Excludes this parameter from query
      }

      if (this.seldFacs.find(itm => itm === '0')) {
        this.seldFacs = ['0'];
      } else if (this.seldFacs.length === 1 && this.seldFacs[0] === '') {
        this.seldFacs = []; // Excludes this parameter from query
      }

      if (this.seldLocales.find(itm => itm === '0')) {
        this.seldLocales = ['0'];
      } else if (this.seldLocales.length === 1 && this.seldLocales[0] === '') {
        this.seldLocales = [];  // Excludes this parameter from query
      }

      switch (this.seldRpt) {
        case 1: // Dtx
          this.initRptData();

          this.seldProvsIDsSignal.set(this.seldProvs.join(','));
          this.seldFacsIDsSignal.set(this.seldFacs.join(','));
          qry = "EXEC dbo.spRptDtx";  // With no parameters this retrieves the already created views
          if (nuevo) {  // This creates a new view with the following parameters
            qry += " @viewNm = 'new', @FromDt = '" + frMom.format('M/D/YY') + "', @ToDt = '" + toMom.format('M/D/YY') + "', @UserNm = '" + this.userFirstNm + "', @UserID = '" + this.userID + "'";

            if (this.seldProvs.length) {
              qry += ", @ProvID = '|" + this.seldProvs.join('|') + "|'";
            }
            if (this.seldFacs.length) {
              qry += ", @FacID = '|" + this.seldFacs.join('|') + "|'";
            }
            if (this.seldLocales.length) {
              qry += ", @LocaleNo = '|" + this.seldLocales.join('|') + "|'";
            }
            if (this.rptOptionsSignal().find(o => o.value === 'officeOnly') && !this.rptOptionsSignal().find(o => o.value === 'nonOfficeOnly')) {
              qry += ", @OHA = 'O'";
            }
            if (this.rptOptionsSignal().find(o => o.value === 'nonOfficeOnly') && !this.rptOptionsSignal().find(o => o.value === 'officeOnly')) {
              qry += ", @OHA = 'H'";
            }
          } else {
            if (this.rptDtxDataSignal().views.length) { // Avoid re-loading views
              this.rptDtxLoaded = true;
              return;
            }
          }
          break;

        case 2: // Esp vs Cob
          this.initRptData();

          this.seldProvsIDsSignal.set(this.seldProvs.join(','));
          this.seldInses1IDsSignal.set(this.seldInses1.join(','));
          this.seldInses2IDsSignal.set(this.seldInses2.join(','));
          this.seldFacsIDsSignal.set(this.seldFacs.join(','));
          qry = "EXEC dbo.spRptEspVsCob2";  // With no parameters this retrieves the already created views
          if (nuevo) {  // This creates a new view with the following parameters
            qry += " @viewNm = 'new', @FromDt = '" + frMom.format('YYYYMMDD') + "', @ToDt = '" + toMom.format('YYYYMMDD') + "', @UserNm = '" + this.userFirstNm + "', @UserID = '" + this.userID + "'";

            if (this.seldProvs.length) {
              qry += ", @ProvID = '|" + this.seldProvs.join('|') + "|'";
            }
            if (this.seldInses1.length) {
              qry += ", @Ins1ID = '|" + this.seldInses1.join('|') + "|'";
            }
            if (this.seldInses2.length) {
              qry += ", @Ins2ID = '|" + this.seldInses2.join('|') + "|'";
            }
            if (this.seldFacs.length) {
              qry += ", @FacID = '|" + this.seldFacs.join('|') + "|'";
            }
            if (this.seldLocales.length) {
              qry += ", @LocaleNo = '|" + this.seldLocales.join('|') + "|'";
            }

            if (this.rptOptionsSignal().find(o => o.value === 'officeOnly') && !this.rptOptionsSignal().find(o => o.value === 'nonOfficeOnly')) {
              qry += ", @OHA = 'O'";
            } else if (this.rptOptionsSignal().find(o => o.value === 'nonOfficeOnly') && !this.rptOptionsSignal().find(o => o.value === 'officeOnly')) {
              qry += ", @OHA = 'H'";
            } else {
              qry += ", @OHA = 'A'";
            }
            if (this.rptOptionsSignal().find(o => o.value === 'woAnyPay')) {
              qry += ", @WoAnyPay = 1";
            }
            if (this.rptOptionsSignal().find(o => o.value === 'exclPvdo')) {
              qry += ", @exclPvdo = 1";
            }
          } else {
            if (this.rptEspCobDataSignal().views.length) { // Avoid re-loading views
              this.rptEspCobLoaded = true;
              return;
            }
          }
          break;

        case 3: // Income
          this.initRptData();

          this.seldProvsIDsSignal.set(this.seldProvs.join(','));
          this.seldFacsIDsSignal.set(this.seldFacs.join(','));
          qry = "EXEC dbo.spRptIncome2";
          if (nuevo) {  // This creates a new view with the following parameters
            qry += "  @viewNm = 'new', @FromDt = '" + fromDt + "', @ToDt = '" + toDt + "'";  //, @ProvID = 61, @OHA = 'A', @GrpByRxDt = 0, @InclPvdo = 0, @PvdoOnly = 0";

            if (this.seldLocales.length && this.seldLocales.join(',') > '') {
              qry += ", @OfficeNo = '" + this.seldLocales.join(',') + "'";
            }
            if (this.seldProvs.length) {
              qry += ", @ProvID = '|" + this.seldProvs.join('|') + "|'";
            }
            if (this.seldFacs.length) {
              qry += ", @FacID = '|" + this.seldFacs.join('|') + "|'";
            }
            if (this.seldLocales.length) {
              qry += ", @LocaleNo = '|" + this.seldLocales.join('|') + "|'";
            }

            if (this.rptOptionsSignal().find(o => o.value === 'officeOnly') && !this.rptOptionsSignal().find(o => o.value === 'nonOfficeOnly')) {
              qry += ", @OHA = 'O'";
            } else if (this.rptOptionsSignal().find(o => o.value === 'nonOfficeOnly') && !this.rptOptionsSignal().find(o => o.value === 'officeOnly')) {
              qry += ", @OHA = 'H'";
            } else {
              qry += ", @OHA = 'A'";
            }
            if (this.rptOptionsSignal().find(o => o.value === 'woAnyPay')) {
              qry += ", @WoAnyPay = 1";
            }
            if (this.rptOptionsSignal().find(o => o.value === 'exclPvdo')) {
              qry += ", @exclPvdo = 1";
            }
            if (this.rptOptionsSignal().find(o => o.value === 'grpByRxDt')) {
              qry += ", @GrpByRxDt = 1";
            } else {
              qry += ", @GrpByRxDt = 0";
            }
          } else {
            console.log('rptIncomeDataSignal().views', this.rptIncomeDataSignal().views);

            if (this.rptIncomeDataSignal().views.length) { // Avoid re-loading views
              this.rptIncomeLoaded = true;
              return;
            }
          }
          break;

        case 4: // Aging
          this.rptAgingData = {
            ins: [],
            clm: [],
            det: [],
            pad: []
          };

          qry = "EXEC dbo.spRptAging2 @FromDt = '" + fromDt + "', @ToDt = '" + toDt + "'";

          if (this.seldLocales.length && this.seldLocales.join(',') > '') {
            qry += ", @OfficeNo = '" + this.seldLocales.join(',') + "'";
          }

          if (this.seldProvs.length && this.seldProvs.join(',') > '') {
            qry += ", @ProvID = '" + this.seldProvs.join(',') + "'";
          }

          if (this.seldFacs.length && this.seldFacs.join(',') > '') {
            qry += ", @FacID = '" + this.seldFacs.join(',') + "'";
          }

          if (this.seldInses1.length && this.seldInses1.join(',') > '') {
            qry += ", @Ins1ID = '" + this.seldInses1.join(',') + "'";
          }

          if (this.seldInses2.length && this.seldInses2.join(',') > '') {
            qry += ", @Ins2ID = '" + this.seldInses2.join(',') + "'";
          }

          if (this.rptOptionsSignal().find(o => o.value === 'ignorPayAftToDt')) {
            qry += ", @IgnorPayAftToDt = 1"
          }

          if (this.rptOptionsSignal().find(o => o.value === 'woAnyPay')) {
            qry += ", @WoAnyPay = 1"
          }

          if (this.rptOptionsSignal().find(o => o.value === 'deferSecndry')) {
            qry += ", @DeferSecndry = 1"
          }

          if (this.rptOptionsSignal().find(o => o.value === 'exclPvdo')) {
            qry += ", @InclPvdo = 0"
          } else {
            qry += ", @InclPvdo = 1"
          }

          if (this.rptOptionsSignal().find(o => o.value === 'officeOnly') && this.rptOptionsSignal().find(o => o.value === 'nonOfficeOnly')) {
            qry += ", @OHA = 'X'" // Yeilds nothing
          } else if (this.rptOptionsSignal().find(o => o.value === 'officeOnly')) {
            qry += ", @OHA = 'O'"
          } else if (this.rptOptionsSignal().find(o => o.value === 'nonOfficeOnly')) {
            qry += ", @OHA = 'H'"
          }

          break;
      }

      window.scroll(0, 0);
      console.log('%c' + 'query ' + qry + ';', 'color: green; background: yellow; font-size: 12px');
      this.spinnerSignal.set(true);
      this._websocketService.sendChat('query', this._recordService.sn, qry);

      this.markLastUsedRpt()
    }
  }

  loadLastUsedParamsFromArray(): void {
    if (!this.seldRpt && this.lastUsedParamsArr.length > 0) {
      this.seldRpt = +(this.lastUsedParamsArr.find(p => p.lastUsed === 1)?.seldRpt ?? '');  // Default to last used report id marked lastUsed = 1
    }

    let rptIndx = this.lastUsedParamsArr.findIndex(p => +p.seldRpt === this.seldRpt);

    if (this.lastUsedParamsArr?.length > 0 && rptIndx > -1) {
      const dfMom = moment(this.lastUsedParamsArr[rptIndx].fromDt, 'MM/DD/YYYY');
      if (dfMom.isValid()) {
        this.seldFromDtSignal.set(dfMom.toDate());
      }
      const dtMom = moment(this.lastUsedParamsArr[rptIndx].toDt, 'MM/DD/YYYY');
      if (dtMom.isValid()) {
        this.seldToDtSignal.set(dtMom.toDate());
      }

      this.seldProvs = this.lastUsedParamsArr[rptIndx].prov.split(',');
      this.seldInses1 = this.lastUsedParamsArr[rptIndx].ins1.split(',');
      this.seldInses2 = this.lastUsedParamsArr[rptIndx].ins2.split(',');
      this.seldFacs = this.lastUsedParamsArr[rptIndx].fac.split(',');
      this.seldLocales = this.lastUsedParamsArr[rptIndx].loc.split(',');

      this.lastUsedParamsArr[rptIndx].opt.split(',').forEach((o) => {
        let oobj = this.options.find(op => op.value === o) ?? null;
        if (oobj) {
          this.rptOptionsSignal.set([...this.rptOptionsSignal(), oobj]);
        }
      });
    } else {
      this.updateLastUsedParamsArray();
    }

    if (this.seldRpt === 0 && rptIndx > -1) {
      this.seldRpt = +this.lastUsedParamsArr[rptIndx].seldRpt;  // Default to last used report
    }

    console.log('lastUsedParamsArray() current', this.lastUsedParamsArr);
  }

}
